export default "__VITE_ASSET__8316d926__"